import {
    AfterViewInit, ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChildren,
    ViewContainerRef
} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface, ISurveySelectedEvent, SurveyFormItemComponentInterface} from '../../../../interface/component';
import {IActionPassData, IFormItemsControls} from '../../../../interface/form-structure';
import {HttpFormDataService} from '../../../../services/services';
import {GlobalObjectService} from '../../../../class/global-obj';
import {IHttpSetting} from '../../../../interface/dataset-params';
import * as _ from 'lodash';

export interface SurveyQuestionStructure {
    survey_id: number;
    id: number;
    answer_control_id: string;
    question_text?: string;
    question_image?: string;
    list_order: number;
    is_require: boolean;
    answers: IAnswers[];
}

export interface IAnswers {
    list_order: number;
    text: string;
    image: string;
    point: number;
    id: any;
    require_value: boolean;
    value_label: string;
    selected_warning: string;
}


@Component({
    selector: 'noos-survey',
    templateUrl: './survey.component.html',
    styleUrls: ['./survey.component.scss']
})
@NoosFormTypeService.register('survey')
export class SurveyComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    @ViewChildren('dynamic', {read: ViewContainerRef}) public widgetTargets: QueryList<ViewContainerRef>;

    prop: IFormItemsControls;
    isFilter = false;
    thisAppearance: any = 'outline';
    setting: IHttpSetting;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    actionPassedData: IActionPassData = null;


    surveyReturns: ISurveySelectedEvent[] = [];
    isAllDataOk = false;

    itemData: SurveyQuestionStructure[] = [];

    constructor(private httpService: HttpFormDataService,
                private componentFactoryResolver: ComponentFactoryResolver,
                private noosFormTypeFactory: NoosFormTypeService,
                private cd: ChangeDetectorRef) {
        this.setting = GlobalObjectService.getVar('setting');
    }

    ngOnInit(): void {
        this.actionPassedData = GlobalObjectService.getVar('action_data_' + this.formId.toString());
    }


    ngAfterViewInit(): void {
        this.loadSurvey();
    }


    loadSurvey() {
        let survey_id = this.prop.options.survey_id;

        if (this.prop.options.dynamic_get_prequery !== undefined) {
            if (this.actionPassedData !== null && this.actionPassedData !== undefined && this.actionPassedData.preQuery !== undefined) {
                const preQuery = this.actionPassedData.preQuery.filter(x => x.field_name === this.prop.name
                    && x.field_dataset_id === this.prop.options.dataset_id && x.operator.value === '=' && x.value.length > 0);
                if (preQuery.length > 0) {
                    survey_id = preQuery[0].value[0].value;
                    this.prop.defaultValue = survey_id;
                    this.prop.options.survey_id = survey_id;
                }
            }
        }

        this.httpService.getSurveyQuestions(this.setting, this.prop.options.dataset_id, survey_id).subscribe(ret => {
            if (ret.complete) {
                this.itemData = _.orderBy(ret.data, ['list_order'], ['asc']);

                this.widgetTargets.changes.subscribe(() => {
                    this.compileForm();
                });
                this.compileForm();
            }
        });
    }


    compileForm() {

        for (let i = 0; i < this.widgetTargets.toArray().length; i++) {
            const conf = this.itemData[i];
            if (conf) {
                const target = this.widgetTargets.toArray()[i];
                target.clear();
                const component = this.noosFormTypeFactory.getPostTypeFromString('survey-' + conf.answer_control_id);
                if (component === null) {
                    return;
                }
                const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
                const componentRef = target.createComponent(componentFactory);
                (componentRef.instance as SurveyFormItemComponentInterface).prop = conf;
                (componentRef.instance as SurveyFormItemComponentInterface).isView = false;
                (componentRef.instance as SurveyFormItemComponentInterface).datasetId = this.datasetId;
                (componentRef.instance as SurveyFormItemComponentInterface).formId = this.formId;
                (componentRef.instance as SurveyFormItemComponentInterface).isFilter = this.isFilter;
                (componentRef.instance as SurveyFormItemComponentInterface).index = i + 1;
                (componentRef.instance as SurveyFormItemComponentInterface).selectedValue
                    .subscribe((ret: ISurveySelectedEvent) => {
                        const isQ = this.surveyReturns.filter(x => x.question.id === ret.question.id);
                        if (isQ.length === 0) {
                            this.surveyReturns.push(ret);
                        } else {
                            isQ[0] = ret;
                        }

                        this.isAllDataOk = true;
                        this.itemData.forEach(t => {
                            if (t.is_require) {
                                const isQ2 = this.surveyReturns.filter(x => x.question.id === t.id
                                    && x.answers !== undefined && x.answers.length > 0);
                                if (isQ2.length === 0) {
                                    this.isAllDataOk = false;
                                }
                            }
                        });

                        if (this.isAllDataOk) {
                            this.prop.defaultValue = this.prop.options.survey_id;
                            this.prop.defaultValueTitle = this.surveyReturns;
                        } else {
                            this.prop.defaultValue = '';
                            this.prop.defaultValueTitle = [];
                        }

                    });
                componentRef.changeDetectorRef.detectChanges();
                this.cd.detectChanges();


            }
        }

    }

}
